export default __webpack_public_path__ + "static/media/researchEO.50b9b928.jpg";